// Purpose: TikTok integration API calls
// Caller: TikTokItemPage
// Dependencies: utils/xhr
// Main Functions: getTiktokItems
// Side Effects: HTTP GET /tiktok/item

import { xhr } from "utils";

export const getTiktokItems = (params) => xhr.get(`/tiktok/item?${params}`);
export const getTiktokItemDetail = (id) => xhr.get(`/tiktok/item/${id}`);
export const updateTiktokItemSkus = (itemId, data) =>
  xhr.post(`/tiktok/item/${itemId}`, data);
